import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { applySelectors } from 'utils/selectors'
import { getDisplayName } from 'utils/containers'
import { orgHandle } from 'app/modules/org/selectors'
import * as ProfileSelectors from './selectors'
import * as ProfileActions from './actions'
import { actions as TrackingActions } from 'app/modules/tracking'

export const withProfile = (
  selectors = ProfileSelectors,
  options = { blocking: false }
) => InnerComponent => {
  class ProfileContainer extends Component {
    componentWillMount() {
      this.props.actions.fetchCurrentProfile()
    }

    render() {
      if (options.blocking && !this.props.isLoaded) return false

      return <InnerComponent {...this.props} />
    }
  }

  ProfileContainer.displayName = `withProfile(${getDisplayName(InnerComponent)})`

  function mapStateToProps(state) {
    const appliedSelectors = options.blocking
      ? { isLoaded: ProfileSelectors.isLoaded, ...selectors, orgHandle }
      : selectors

    return applySelectors(appliedSelectors, state)
  }

  function mapDispatchToProps(dispatch) {
    return {
      actions: bindActionCreators({ ...ProfileActions, track: TrackingActions.track }, dispatch),
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)(ProfileContainer)
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/profile/container.js